import { render } from "./ClipboardSearchIcon.vue?vue&type=template&id=6a1ec9d6"
import script from "./ClipboardSearchIcon.vue?vue&type=script&lang=js"
export * from "./ClipboardSearchIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__